import { render, staticRenderFns } from "./areaAndProductTj.vue?vue&type=template&id=01a1e042&scoped=true&"
import script from "./areaAndProductTj.vue?vue&type=script&lang=js&"
export * from "./areaAndProductTj.vue?vue&type=script&lang=js&"
import style0 from "./areaAndProductTj.vue?vue&type=style&index=0&id=01a1e042&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a1e042",
  null
  
)

export default component.exports